import { render, staticRenderFns } from "./FactoryManage.vue?vue&type=template&id=6f4f8533&scoped=true&"
import script from "./FactoryManage.vue?vue&type=script&lang=js&"
export * from "./FactoryManage.vue?vue&type=script&lang=js&"
import style0 from "./FactoryManage.vue?vue&type=style&index=0&id=6f4f8533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f8533",
  null
  
)

export default component.exports